import { BaseComponent } from '../../components/base-component'
import { PredictiveSearchAPI } from '../../api/search-api'
import {
  getTemplateFirstChild,
  parseHTML,
  replaceNodeChildren,
} from '../../utils/dom'
import { debounce } from '../../utils/debounce'
import { SearchSidebar } from './search-sidebar'
import { SearchField } from 'src/scripts/components/inputs'
import { $el, $list, $elParent } from 'src/scripts/utils/utils'

const SEARCH_FIELD_SELECTOR = `[data-sidebar-search-input-component]`
const CONTENT_RESULTS_SELECTOR = `[data-sidebar-search-content-results]`
const FOOTER_SELECTOR = `[data-sidebar-search-footer]`
const ITEM_SELECTOR = `[data-sidebar-search-item]`
const SEARCH_SIDEBAR_SELECTOR = '#SearchSidebar'

export class SearchSidebarFormWrapper extends BaseComponent {
  predictiveSearchAPI: PredictiveSearchAPI = new PredictiveSearchAPI()

  mountComponent(): void {
    this.addListener(this, 'input', this.handleInputChange)
  }

  handleInputChange = debounce((): void => {
    if (this.searchQuery) {
      this.renderResults()
    } else {
      this.resetResults()
    }
  }, 500)

  renderResults(): void {
    this.renderFromUrl(this.searchQuery)
  }

  resetResults(): void {
    const sidebar: SearchSidebar = $elParent(SEARCH_SIDEBAR_SELECTOR, this)

    if (!sidebar) {
      return
    }

    this.updateResultsFromHTML(sidebar.defaultStateElement)
  }

  renderFromUrl(queryKey: string): void {
    const sidebar: SearchSidebar = $elParent(SEARCH_SIDEBAR_SELECTOR, this)
    const sectionId = sidebar?.dataset.sectionId || 'search-sidebar'
    const limitParam = 'resources[limit]=999' || ''
    const sectionParam = `section_id=${sectionId}` || ''
    const fieldsParam = sidebar?.hasAttribute('enable-extended-search')
      ? 'resources[options][fields]=author,body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor'
      : 'resources[options][fields]=title,product_type,variants.title,vendor'

    this.predictiveSearchAPI
      .get({
        searchQuery: queryKey,
        limitParam,
        sectionParam,
        fieldsParam,
      })
      .then(text => {
        this.updateResultsFromHTML(parseHTML(text).body)
      })
      .catch(() => {
        console.log('Error in search component')
      })
  }

  updateResultsFromHTML(html: HTMLElement): void {
    const newSidebar = $el(SEARCH_SIDEBAR_SELECTOR, html)
    let element

    if (newSidebar) {
      const template = $el(
        '[data-sidebar-template="SearchSidebar"]',
        newSidebar,
      )
      element = getTemplateFirstChild(template)
    } else {
      element = html
    }

    const sidebar: SearchSidebar = $elParent(SEARCH_SIDEBAR_SELECTOR, this)
    const newResults = $el(CONTENT_RESULTS_SELECTOR, element)
    const results = $el(CONTENT_RESULTS_SELECTOR, sidebar?.element)
    replaceNodeChildren(results, newResults)

    this.updateFooterVisible()
  }

  updateFooterVisible(): void {
    const sidebar: SearchSidebar = $elParent(SEARCH_SIDEBAR_SELECTOR, this)

    if (sidebar) {
      const footer = $el(FOOTER_SELECTOR, sidebar.element)

      if (footer) {
        const renderedItems = $list(ITEM_SELECTOR, sidebar.element)
        footer.classList.toggle('hidden', renderedItems.length === 0)
      }
    }
  }

  get searchQuery(): string {
    const sidebar: SearchSidebar = $elParent(SEARCH_SIDEBAR_SELECTOR, this)
    const searchField: SearchField = $el(SEARCH_FIELD_SELECTOR, sidebar)

    if (!searchField) {
      return ''
    }

    return searchField.value.trim()
  }
}
